// @flow
import { TextField } from '@src/formik-utils/FormFields';
import { TEXT_NUMBER_INPUT_TYPE } from '@src/formik-utils/consts';
import React from 'react';
import { areAllValuesInGivenObjectNonNull, pickKeysFromObject } from '@src/common-utils/utils';
import {
  getDimensionsPath,
  getIfAnyOtherRowBesidesTheGivenRowIsBeingEdited,
  getMetricDimensionsFromMetricName,
} from '@streaming-projects/user-commit-details/committed-capacity/utils';
import { IS_ROW_OPENED_FOR_EDITING } from '@src/constants';
import { useFormikContext } from 'formik';

export const QuantityContainer = ({
  dimensionRow,
  metricRow,
  configuredMetrics,
  metricIndex,
  dimensionIndex,
}) => {
  const { setFieldValue } = useFormikContext();

  // Check if all the dimensions are set, if not, it should be disabled
  // Also, if there is any in progress row, outside of this row,  then also, disable those guys, but enable this guy
  const isAnyOtherRowBesidesTheGivenRowBeingEdited =
    getIfAnyOtherRowBesidesTheGivenRowIsBeingEdited(configuredMetrics, dimensionRow);

  const shouldQuantityBeDisabled =
    !areAllValuesInGivenObjectNonNull(
      pickKeysFromObject(dimensionRow, getMetricDimensionsFromMetricName(metricRow.metricName))
    ) || isAnyOtherRowBesidesTheGivenRowBeingEdited;

  const dimensionsPath = getDimensionsPath(metricIndex, dimensionIndex);
  const quantityPath = `${dimensionsPath}.quantity`;
  const inProgressFieldName = `${dimensionsPath}.${IS_ROW_OPENED_FOR_EDITING}`;

  return (
    <TextField
      addLabel={false}
      disableOnFormErrors={null}
      disabled={shouldQuantityBeDisabled}
      fieldDisplayName="Quantity"
      fieldName={quantityPath}
      onChange={async () => {
        await setFieldValue(inProgressFieldName, true);
      }}
      placeholder="Quantity"
      type={TEXT_NUMBER_INPUT_TYPE}
    />
  );
};
